module.exports = __webpack_public_path__ + "static/media/6.984e7162.JPG";